import { Component, OnInit } from '@angular/core';
import { IsentropicService } from '../../isentropic.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'rpe-if-mach',
    templateUrl: './if-mach.component.html',
    styleUrl: './if-mach.component.scss',
    standalone: false
})
export class IfMachComponent implements OnInit {

  machForm: FormGroup;
  mBool: boolean;
  machV: number;
  gammaV: number;
  machMap:Map<string, number>;

  constructor(private fBuilder: FormBuilder, private isentropicService: IsentropicService) {
    this.machForm = this.fBuilder.nonNullable.group({
      machVal: ['', [
        Validators.required
      ]],
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]]
    });
    this.machMap = new Map;
    this.gammaV = 0;
    this.machV = 0;
    this.mBool = false;
  }

  ngOnInit() {
    this.machForm = this.fBuilder.group({
      machVal: ['', [
        Validators.required
      ]],
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]]
    })
  }
  onSubmit(): void {
    this.mBool = true;
    

    // if (this.machForm.get('machVal')) {
      this.machV = this.machForm.get('machVal')!.value;  
    // }

    // if (this.machForm.get('gammaVal')) {
        
      this.gammaV = this.machForm.get('gammaVal')!.value;
  
    // }

    this.machMap = this.isentropicService.getIsentropic(this.gammaV, this.machV);
  }

  hypersonicWarning(): void {
    this.machV = this.machForm.get('machVal')!.value;
    console.log(this.machV);
  }

  get machVal() {
    return this.machForm.get('machVal');
  }

  isenp_pt():number {
    // if (this.machMap.get)
    return this.machMap.get("p_pt")!;
  }

  isenT_Tt():number {
    return this.machMap.get("T_Tt")!;
  }

  isenA_As() {
    return this.machMap.get("A_A*")
  }

  isenpA_ptAstar():number {
    return this.machMap.get("pA_ptA*")!;
  }

  isenpm() {
    return this.machMap.get("Prandlt-Meyer");
  }

  isenmach_angle() {
    return this.machMap.get("mach-angle");
  }
  isen_cfopt() {
    return this.machMap.get("C_Fopt");
  }

  isen_rhot() {
    return this.machMap.get("rho/rhot");
  }


}
